import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount, useBalance, useDisconnect } from 'wagmi';

const WalletPage = ({ selectedChainId, setSelectedChainId }) => {
  const { isConnected, address } = useAccount();
  const { disconnect } = useDisconnect();

  const chains = [
    { id: 1, name: 'Ethereum', symbol: 'ETH' },
    { id: 8453, name: 'Base', symbol: 'ETH' },
    { id: 42161, name: 'Arbitrum', symbol: 'ETH' },
    { id: 43114, name: 'Avalanche', symbol: 'AVAX' },
    { id: 10, name: 'Optimism', symbol: 'ETH' },
    { id: 324, name: 'zkSync', symbol: 'ETH' },
    { id: 137, name: 'Polygon (Matic)', symbol: 'POL' },
    { id: 56, name: 'BNB Smart Chain', symbol: 'BNB' },
    { id: 534352, name: 'Scroll', symbol: 'ETH' },
    { id: 80094, name: 'Berachain', symbol: 'BERA' },
    { id: 2741, name: 'Abstract', symbol: 'ETH' },
    { id: 7777777, name: 'Zora', symbol: 'ETH' },
    { id: 728126428, name: 'Tron', symbol: 'TRX' },
    { id: 1329, name: 'Sei', symbol: 'SEI' },
  ];
  


  const { data: balance, isLoading, isError } = useBalance({
    address,
    chainId: selectedChainId,
  });

  const handleChainChange = (event) => {
    setSelectedChainId(Number(event.target.value));
  };

  return (
    <div className="flex items-start justify-center min-h-screen bg-[#0d0d0d] p-0">
      <div className="w-full max-w-sm mt-8 bg-[#1a1a1a] rounded-[1.5rem] shadow-[0_8px_30px_rgba(0,0,0,0.8)] p-6 space-y-5 border border-[#2a2a2a]">
        <h3 className="text-2xl font-semibold text-center text-gray-100 tracking-tight">
          <span className="block text-gray-500 text-sm uppercase">Web3 Access</span>
        </h3>

        <div className="flex justify-center">
          {!isConnected ? (
            <ConnectButton
              chainStatus="icon"
              showBalance={false}
              label="Connect Wallet"
              className="bg-gradient-to-br from-teal-600 to-blue-700 text-white px-6 py-1 rounded-xl"
            />
          ) : (
            <div className="text-center space-y-3">
              <p className="text-xs text-teal-400">
                {address?.slice(0, 14)}...{address?.slice(-4)}
              </p>
              <button
                onClick={disconnect}
                className="bg-gradient-to-r from-red-600 to-rose-500 text-white px-6 py-1 rounded-xl"
              >
                Disconnect
              </button>
            </div>
          )}
        </div>

        <div className="mt-4 text-center">
          <label htmlFor="chainSelect" className="text-sm text-gray-500">Select Chain</label>
          <select
            id="chainSelect"
            value={selectedChainId}
            onChange={handleChainChange}
            className="w-full p-3 bg-[#0f0f0f] text-white border border-gray-700 rounded-xl text-sm mt-2"
          >
            {chains.map((chain) => (
              <option key={chain.id} value={chain.id}>
                {chain.name}
              </option>
            ))}
          </select>
        </div>

        <div className="text-center mt-4">
          {isLoading ? (
            <p className="text-sm text-gray-400">Loading balance...</p>
          ) : isError ? (
            <p className="text-sm text-red-500">Error fetching balance</p>
          ) : (
            <>
              <h4 className="text-xs text-gray-500 uppercase tracking-widest">Balance</h4>
              <div className="mt-2 bg-[#111111] p-4 rounded-xl border border-gray-700">
                <p className="text-2xl font-bold text-amber-400">
                  {balance ? `${parseFloat(balance.formatted).toFixed(4)} ${balance.symbol}` : '0.0000 ETH'}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletPage;
